export const GET_SHOP_DIAMOND = "GET_SHOP_DIAMOND";
export const BUY_DIAMOND = "BUY_DIAMOND";
export const OPEN_DIAMOND_SHOP_DIALOG = "OPEN_DIAMOND_SHOP_DIALOG";
export const CLOSE_DIAMOND_SHOP_DIALOG = "CLOSE_DIAMOND_SHOP_DIALOG";
